export async function getWOConfigs() {
    let href = window.location.href,
        url = href.split('/')[2];

    let woResponse = await fetch(`/api/v2/WorkOrderConfigs/url?url=${url}`, {
        mode: "cors",
        method: "GET",
        cache: 'no-cache',
        headers: {
            'Content-Type': 'application/json'
        }
    }),
        woResponseType = woResponse.headers.get("content-type");

    if (woResponseType && woResponseType.indexOf('application/json') != -1) {
        let woConfig = await woResponse.json();

        return woConfig;
    }
    else {
        return {};
    }
}


// WEBPACK FOOTER //
// ./src/services/padre.js